import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'chevron-up-right', 'IconChevronUpRight', [["path",{"d":"M8 8h8v8","key":"svg-0"}]]);